<pds-module-header title="Operações">
  <pds-new-breadcrumb [items]="[{ label: 'Operações' }]" />

  <div class="operations">
    <a *allowTo="[['operacoes-otimizador-1'], ['operacoes-otimizador-2'], ['operacoes-otimizador-3']]" class="operations__card" [routerLink]="['/operacoes', 'otimizador']" title="Otimizador">
      <h2 class="operations__card__title">Otimizador</h2>
      <div class="operations__card__subtitle">Permite configurar as regras do otimizador</div>
    </a>

    <a *allowTo="[['operacoes-regioes-1'], ['operacoes-regioes-2'], ['operacoes-regioes-3']]" class="operations__card" [routerLink]="['/operacoes', 'regioes']" title="Regiões">
      <h2 class="operations__card__title">Regiões</h2>
      <div class="operations__card__subtitle">Permite consultar e cadastrar regiões de atendimento</div>
    </a>

    <a *allowTo="[['operacoes-feriados-1'], ['operacoes-feriados-2'], ['operacoes-feriados-3']]" class="operations__card" [routerLink]="['/operacoes', 'feriados']" title="Feriados">
      <h2 class="operations__card__title">Feriados</h2>
      <div class="operations__card__subtitle">Permite consultar e cadastrar feriados</div>
    </a>

    <a
      *allowTo="[['operacoes-restricao-vendedores-1'], ['operacoes-restricao-vendedores-2'], ['operacoes-restricao-vendedores-3']]"
      class="operations__card"
      [routerLink]="['/operacoes', 'restricao-vendedores']"
      title="Restrição Vendedores"
    >
      <h2 class="operations__card__title">Restrição Vendedores</h2>
      <div class="operations__card__subtitle">Permite gerenciar restrições comerciais por canais e vendedores</div>
    </a>

    <a *allowTo="[['operacoes-anymarket-1'], ['operacoes-anymarket-2'], ['operacoes-anymarket-3']]" class="operations__card" [routerLink]="['/operacoes', 'anymarket']" title="Anymarket">
      <h2 class="operations__card__title">Anymarket</h2>
      <div class="operations__card__subtitle">Permite gerenciar as configurações e publicações no Anymarket</div>
    </a>

    <a
      *allowTo="[['operacoes-padroes-grupo-produtos-1'], ['operacoes-padroes-grupo-produtos-2'], ['operacoes-padroes-grupo-produtos-3']]"
      class="operations__card"
      [routerLink]="['/operacoes', 'padroes-grupo-produtos']"
      title="Padrões de grupo de produtos"
    >
      <h2 class="operations__card__title">Padrões de grupo de produtos</h2>
      <div class="operations__card__subtitle">Permite gerenciar padrões de especificações para grupos de produtos</div>
    </a>
  </div>
</pds-module-header>
